import { applyMiddleware, compose, createStore } from 'redux';
import reduxImmutableStateInvariant from 'redux-immutable-state-invariant';
import createSagaMiddleware from 'redux-saga';

import { initSagas } from '@topconagriculture/frontend-utils';

import rootReducer from '../reducers';
import * as sagas from '../sagas';
import { routerMiddleware } from './history';

const sagaMiddleware = createSagaMiddleware();

declare global {
  interface Window {
    __REDUX_DEVTOOLS_EXTENSION_COMPOSE__: any;
    grecaptcha: any;
    onGrecaptchaLoadCallback: any;
  }
}

export default function configureStore(initialState: {} = {}) {
  const middlewares = [
    // Redux middleware that spits an error on you when you
    // try to mutate your state either inside a dispatch or between dispatches.
    reduxImmutableStateInvariant(),
    sagaMiddleware,
    routerMiddleware,
    // createLogger(),
  ];

  // add support for Redux dev tools
  const composeEnhancers = (window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ as any)
    ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
        // TODO Try to remove when `react-router-redux` is out of beta,
        // LOCATION_CHANGE should not be fired more than once after hot reloading
        // Prevent recomputing reducers for `replaceReducer`
        shouldHotReload: true,
      })
    : compose;

  const store: any = createStore(rootReducer, initialState, composeEnhancers(applyMiddleware(...middlewares)));

  initSagas(sagas, sagaMiddleware);

  if (module.hot) {
    // Enable Webpack hot module replacement for reducers
    module.hot.accept('../reducers', () => {
      // eslint-disable-next-line @typescript-eslint/no-var-requires
      const nextReducer = require('../reducers').default;
      store.replaceReducer(nextReducer);
    });
  }
  return store;
}
